import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, Fragment as _Fragment, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, mergeProps as _mergeProps, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "qin-form qin-form--modal" }
const _hoisted_2 = { class: "qin-form__title" }
const _hoisted_3 = {
  key: 0,
  class: "ds-caption ds-caption--size_2xl ds-caption--bold"
}
const _hoisted_4 = { class: "ds-caption ds-caption--size_2xl ds-caption--bold ds-caption--appearance_center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "ds-panel ds-panel--space_lg" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ds-panel__element ds-panel__element--offset_bottom" })
], -1)
const _hoisted_6 = { class: "qin-form__subtitle" }
const _hoisted_7 = {
  key: 0,
  class: "ds-caption ds-caption--size_xs ds-caption--color_semigrey"
}
const _hoisted_8 = {
  key: 1,
  class: "ds-caption ds-caption--size_xs ds-caption--color_semigrey ds-caption--appearance_center"
}
const _hoisted_9 = { class: "qin-form__wrapper" }
const _hoisted_10 = { class: "error-label" }
const _hoisted_11 = { class: "g-row g-row--appearance_spaced g-row--space_sm g-row--space_xl-xl g-row--justify_center g-row--align_center" }
const _hoisted_12 = { class: "g-cell g-cols g-cols--narrow" }
const _hoisted_13 = { class: "g-cell g-cols g-cols--12" }
const _hoisted_14 = {
  class: "qin-button qin-button--main qin-button--accent qin-button--full_width",
  type: 'submit'
}
const _hoisted_15 = { class: "qin-button__text" }
const _hoisted_16 = {
  key: 1,
  class: "g-cell g-cols g-cols--12"
}
const _hoisted_17 = { class: "check-icon-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!
  const _component_VeeError = _resolveComponent("VeeError")!
  const _component_d_control_input = _resolveComponent("d-control-input")!
  const _component_i_check_circle = _resolveComponent("i-check-circle")!
  const _component_VeeForm = _resolveComponent("VeeForm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.load)
      ? (_openBlock(), _createBlock(_component_loader, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      (!$setup.dataIsSended)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString($setup.$t('Confirm Your Email')), 1))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("p", _hoisted_4, _toDisplayString($setup.$t('Email is confirmed')), 1),
            _hoisted_5
          ], 64))
    ]),
    _createElementVNode("div", _hoisted_6, [
      (!$setup.dataIsSended)
        ? (_openBlock(), _createElementBlock("p", _hoisted_7, [
            _createElementVNode("p", null, _toDisplayString($setup.$t("Please check your email.")), 1),
            _createElementVNode("p", null, _toDisplayString($setup.$t("A verification code was sent to you")), 1)
          ]))
        : (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString($setup.$t("Your email address has been verified.")), 1))
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_VeeForm, { onSubmit: $setup.request }, {
        default: _withCtx(({ errors }) => [
          _createVNode(_component_VeeError, { name: "nonFieldErrors" }, {
            default: _withCtx(({ message }) => [
              _createElementVNode("div", _hoisted_10, _toDisplayString(message), 1)
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_11, [
            (!$setup.dataIsSended)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.fields, (field) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: field.name,
                      class: "g-cell g-cols g-cols--12"
                    }, [
                      _createVNode(_component_d_control_input, _mergeProps({
                        component: field.tag,
                        "input-label": field.label,
                        name: field.name,
                        rules: field.rules,
                        ref_for: true,
                        ref: field.name,
                        type: field.type
                      }, field, {
                        modelValue: $setup.form[field.name],
                        "onUpdate:modelValue": ($event: any) => (($setup.form[field.name]) = $event),
                        placeholder: field.placeholder || ''
                      }), null, 16, ["component", "input-label", "name", "rules", "type", "modelValue", "onUpdate:modelValue", "placeholder"])
                    ]))
                  }), 128)),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("p", {
                      class: _normalizeClass(["ds-caption ds-caption--color_accent ds-caption--size_sm hovered_underline", {'disabled' : $setup.optIsSended}]),
                      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => ($setup.sendOtp(true)), ["prevent"]))
                    }, _toDisplayString($setup.$t("Didn't get a code? Send Again")), 3)
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("button", _hoisted_14, [
                      _createElementVNode("span", _hoisted_15, _toDisplayString($setup.$t('Send Code')), 1)
                    ])
                  ])
                ], 64))
              : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createVNode(_component_i_check_circle)
                  ])
                ]))
          ])
        ]),
        _: 1
      })
    ])
  ]))
}